export const languageFields = (item, field, i18n, localizedField = `${field}_nl`) => {
    if (!item || !field) return "";

    let lang = "en";

    try {
        lang = i18n?.language || localStorage.getItem("language") || "en";
    } catch (e) {}

    // if dutch language
    if (lang?.toLowerCase().startsWith("nl")) {
        return item?.[localizedField] || item?.[field] || "";
    }

    return item?.[field] || "";
};
